module.exports = __webpack_public_path__ + "img/20211120-122.6aeeadf8.jpg";